let envConfig = {
        remoteLogging: true,
}
export default envConfig;
